<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10 1.19444C6.67134 1.19444 3.97222 3.89356 3.97222 7.22222V12.5C3.97222 13.3136 3.31356 13.9722 2.5 13.9722C2.08579 13.9722 1.75 14.308 1.75 14.7222C1.75 15.1364 2.08579 15.4722 2.5 15.4722H17.5C17.9142 15.4722 18.25 15.1364 18.25 14.7222C18.25 14.308 17.9142 13.9722 17.5 13.9722C16.6864 13.9722 16.0278 13.3136 16.0278 12.5V7.22222C16.0278 3.89356 13.3287 1.19444 10 1.19444ZM14.5278 12.5C14.5278 13.0357 14.6694 13.5382 14.9172 13.9722H5.0828C5.33063 13.5382 5.47222 13.0357 5.47222 12.5V7.22222C5.47222 4.72199 7.49977 2.69444 10 2.69444C12.5002 2.69444 14.5278 4.72199 14.5278 7.22222V12.5Z"
            fill="#8E8E93"
        />
        <path
            d="M11.3333 16.6667C11.5011 16.6667 11.6589 16.7422 11.7644 16.8722C11.87 17.0022 11.9122 17.1733 11.8778 17.3367C11.6855 18.25 10.9133 18.8889 10.0011 18.8889C9.08888 18.8889 8.31665 18.25 8.12443 17.3367C8.08999 17.1733 8.1311 17.0022 8.23665 16.8722C8.34221 16.7422 8.49999 16.6667 8.66776 16.6667H11.3333Z"
            fill="#8E8E93"
        />
    </svg>
</template>
